import { object, string } from "yup";
import * as Yup from "yup";

const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const phonePattern = /^[0-9]{10}$/;

  function generateInviteCode() {
  return Math.floor(100000 + Math.random() * 900000).toString();
}

export const formiksignup = {
  initialValues: {
    firstName: "",
    lastName: "",
    email: "",
    primaryPhone: "",
    gender: "",
    dob: "",
    countyrOpractice: "",
    medicalSpeciality: "",
    medicalSetting: "",
    archived: false,
    active: false,
    role: "DOCTOR",
    about : "",
    invideCode:generateInviteCode(),
  },
  validationSchema: Yup.object({
    email: Yup.string() .max(260, "Email must be at most 260 characters")
      .matches(emailPattern, "Enter a valid email address").test("email-max-length", "Email local part (before @) must be ≤ 60 and domain part (after @) ≤ 200", (value) => {
        if (!value) return false;
        const [local, domain] = value.split("@");
        return local?.length <= 60 && domain?.length <= 200;
      })
      .required("Required Field"),
    firstName: Yup.string()
      .test('not-start-with-number', 'First name cannot start with a number', value => {
        return !/^\d/.test(value);
      })
      .required("Required Field"),
    lastName: Yup.string()
      .test('not-start-with-number', 'Last name cannot start with a number', value => {
        return !/^\d/.test(value);
      })
      .required("Required Field"),
    primaryPhone: Yup.string()
      .matches(phonePattern, "Enter a valid 10 digit phone number")
      .required("Required Field"),
    gender: Yup.string().required("Required Field"),
    dob: Yup.string().required("Required Field"),
    // allow 6 digit invite code 
    invideCode: Yup.string()
      .matches(/^[0-9]{6}$/, "Invite code must be 6 digits long")
      .required("Required Field"),
  }),
};